import { GzRmTopVulnerabilitiesIncidentsWidgetWebComponent } from './component/GzRmTopVulnerabilitiesIncidentsWidgetWebComponent';

export { GzRmTopVulnerabilitiesIncidentsWidgetWebComponent };
